
<div class="xy-container">
  <div class="detail-container">
    <div>
      <div *ngIf="participant$ | async as participant else infoLoader">
        <span class="title-3">Le tue informazioni</span>
        <p><strong>{{ participant.firstname }} {{ participant.lastname }}</strong></p>
        <p>{{ participant.email }}</p>
        <br>
        <p><strong>Utente attivo da</strong></p>
        <p>{{ participant.created | date:'mediumDate' :undefined :'it' }}</p>
      </div>
      <ng-template #infoLoader>
        <app-card-overlay
          [title]="'Caricamento Informazioni'"
          [background]="false"
        ></app-card-overlay>
      </ng-template>
    </div>

    <div>
      <span class="title-3">I tuoi dettagli</span>
      <div class="point-detail-container">

        <ng-container *ngIf="point$ | async as points; else pointsLoader">
          <p><strong>Punti ottenuti</strong>&nbsp;{{ points.earned }}</p>
          <p><strong>Punti usati</strong>&nbsp;{{ points.used }}</p>
          <mat-divider></mat-divider>
          <p><strong>Punti totali</strong>&nbsp;{{ points.balance }}</p>
        </ng-container>

        <ng-template #pointsLoader>
          <app-card-overlay
            [background]="false"
            title="Aggiornamento dettaglio punti" size="small"
          ></app-card-overlay>
        </ng-template>
      </div>
    </div>
  </div>

  <br>
  <br>
  <br>
  <br>

  <ng-container *ngIf="participant$ | async as participant">
    <ng-container *ngIf="!participant?.user?.facebook_id">
      <div class="delete-container" >
        <div>
          <span class="title-3">Cambia Email per il tuo account</span>
          <p>Cambierai la tua email di accesso e di ricezione dei premi
          </p>
          <br>
          <br>
          <button
              class="btn btn-polstar btn-gradient-orange"
              (click)="openNewMailDialogModal()"
          >Cambia Email</button>
        </div>
      </div>
      <br>
      <br>
      <br>
    </ng-container>
  </ng-container>

  <div class="delete-container">
    <div>
      <span class="title-3">Elimina il tuo account</span>

      <p>Se non vuoi più utilizzare pollstar, puoi cancellare il tuo account.
        La cancellazione sarà permanente, non potrai recuperare il tuo account in seguito.
      </p>
      <br>
      <h6>Se decidi di cancellare il tuo account:</h6>
      <ul>
        <li>Non sarai più in grado di effettuare l'accesso a Pollstar.</li>
        <li>
          I tuoi dati saranno completamente cancellati da Pollstar ad eccezione delle risposte che hai dato ai sondaggi.
          <br>
          In ogni caso le tue risposte non saranno in alcun modo riconducibili al tuo account.
          <br>
          Per maggiori informazioni puoi leggere la nostra <a href="https://www.pollstar.it/privacy-policy">Privacy Policy</a>
        </li>
        <li>La lista di premi da te ottenuti sarà eliminata, i tuoi punti saranno azzerati.</li>
        <li><strong>I premi che hai già ricevuto tramite email rimarrano di tua proprietà.</strong></li>
      </ul>
      <br>

      <button
        class="btn btn-polstar btn-gradient-orange"
        (click)="openDeleteDialogModal()"
      >Cancella il mio account</button>

    </div>
  </div>

</div>
